import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { superApi } from "@/lib/superApi";

export default function SuperIndex() {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    superApi
      .get("/super/platform")
      .then((r) => {
        setTarget(r.data?.bootstrapped ? "/super/cliente" : "/super/inicio");
      })
      .catch(() => setTarget("/super/inicio"));
  }, []);

  if (!target) return <div className="text-white/60">Cargando…</div>;
  return <Navigate to={target} replace />;
}
